export const PartnerPageMetric = {
  Partner: 'PartnerPage.partner',
  Access: 'PartnerPage.access',
  GlobalPartner: 'PartnerPage.globalPartner',
  Flags: 'PartnerPage.flags',
  FlagRequests: 'PartnerPage.flagRequests',
  Files: 'PartnerPage.files',
  JbpData: 'PartnerPage.jbpData',
  Contacts: 'PartnerPage.contacts',
} as const

export const SearchMetric = {
  Partners: 'Search.partners',
  Contacts: 'Search.contacts',
  QuickPartners: 'Search.quickPartners',
  QuickContacts: 'Search.quickContacts',
  PartnersAndContacts: 'Search.partnersAndContacts',
} as const
